module.exports = __webpack_public_path__ + "img/2x.05c4f69.jpg";